const Footer = () => {
    return (
        <footer className="Footer">
            <div className="copy">
                &copy; 부산맛집.</div>
            <p>본 사이트는 부산광역시에서 제공해준 부산관광맛집의 이름, 주소, 홈페이지, 전화번호, 좌표, 상세정보를 조회하는 서비스 데이터를 활용하여 제작되었습니다.</p>
        </footer>
    )
}

export default Footer;